import {Component} from '@angular/core';

@Component({
  selector: 'app-async-loading',
  standalone: true,
  imports: [],
  templateUrl: './async-loading.component.html',
  styleUrl: './async-loading.component.scss'
})
export class AsyncLoadingComponent {

}
